import * as React from 'react';
import { ReactComponent as DocPaperIconSVG } from '../../assets/icons/mevo/ic_doc_paper.svg';
import IconPattern, { IconProps } from './_IconPattern';

const DocPaperIcon: React.FunctionComponent<IconProps> = (props) => {
  return <IconPattern component={DocPaperIconSVG} variantPlaces={1} {...props} />;
};

export default DocPaperIcon;
